const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

let accessToken = null;
let authConfig = null;

export function setAccessToken(token) {
  accessToken = token;
}

export function configureAuth(config) {
  authConfig = config;
}

function getAuthHeaders() {
  const headers = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  }
  return headers;
}

async function doRefresh() {
  if (!authConfig || typeof authConfig.getRefreshToken !== 'function') {
    return null;
  }

  const refreshToken = authConfig.getRefreshToken();
  if (!refreshToken) {
    return null;
  }

  const res = await fetch(`${API_BASE}/auth/refresh`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh_token: refreshToken })
  });

  if (!res.ok) {
    return null;
  }

  const data = await res.json();
  const newAccessToken = data && data.access_token;

  if (newAccessToken && authConfig.setAccessToken) {
    authConfig.setAccessToken(newAccessToken);
    accessToken = newAccessToken;
    return newAccessToken;
  }

  return null;
}

async function request(path, options = {}, isRetry = false) {
  const url = `${API_BASE}${path}`;

  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(),
      ...(options.headers || {})
    }
  });

  if (response.status === 401 && !isRetry && authConfig) {
    const refreshed = await doRefresh();
    if (refreshed) {
      return request(path, options, true);
    }
    if (authConfig.onSessionExpired) {
      authConfig.onSessionExpired();
    }
  }

  if (!response.ok) {
    const text = await response.text();
    let message = text;
    try {
      const json = JSON.parse(text);
      if (json && json.detail) {
        message = json.detail;
      }
    } catch (e) {
      // ignore JSON parse errors
    }
    throw new Error(message);
  }

  const contentType = response.headers.get('content-type') || '';
  if (contentType.indexOf('application/json') !== -1) {
    return response.json();
  }

  return response.text();
}

export function get(path) {
  return request(path, { method: 'GET' });
}

export function post(path, body) {
  return request(path, { method: 'POST', body: JSON.stringify(body) });
}

export function put(path, body) {
  return request(path, { method: 'PUT', body: JSON.stringify(body) });
}

export function del(path) {
  return request(path, { method: 'DELETE' });
}

